import { ContentScrollOptions } from "designSystem/components/dialog/ModalDialog";
import { Box, Button, SaveDialog, Text } from "designSystem/index";
import React, { useState } from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import { sortedByGroupItems } from "designSystemLegacy/data";

export default () => {
	const [open, setOpen] = useState(false);
	const onClose = () => setOpen(false);

	const content = sortedByGroupItems.map((x) => x.name)
		.join(",");

	const onButton = (scrollContent: ContentScrollOptions) => {
		setOpen(true);
		setScrollContent(scrollContent);
	};

	const [scrollContent, setScrollContent] = useState<ContentScrollOptions>();

	async function onSave(): Promise<boolean> {
		// simulate time to save changes
		return new Promise((resolve, reject) => {
			setTimeout(() => resolve(true), 1000);
		});
	}

	const onValidate = (scrollContent === "belowMessage") ? () => {
		throw new Error("I'm a validation error message");
	} : null;

	return (
		<Box>
			<CssColumnGrid columns={3}>
				<Button design="primary" onClick={() => onButton("none")}>
					No Scroll
				</Button>
				<Button design="primary" onClick={() => onButton("all")}>
					Content and Message
				</Button>
				<Button design="primary" onClick={() => onButton("belowMessage")}>
					Only Content Below Message
				</Button>
			</CssColumnGrid>
			<SaveDialog
				fullHeight
				onClose={onClose}
				onSave={onSave}
				onValidate={onValidate}
				open={open}
				scrollContent={scrollContent}
				title="Dialog Title"
				width={200}
			>
				{{
					main: (
						<Box>
							<Text text={content} />
						</Box>
					),
				}}
			</SaveDialog>
		</Box>
	);
};